import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import * as R from "ramda"
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';;
import PageLoader from '../../../../../components/PageLoader';
import { selectEdgeGatewaysQueryItems } from '../../../../../redux/edge/gateways/selector';
import { edgeGateways } from '../../../../../redux/edge/gateways/action';
import BppGatewayComponent from '../components/bpp-gateway.component';


const BppGateway = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    console.log('BppGateway parmas', parmas)
    const queryEdgeGatewaysData = useSelector(selectEdgeGatewaysQueryItems)

    const [ selectedEdgeGateway, setSelectedEdgeGateway ] = useState<any>({})

    const fetchGatewayDetails = async (id: any) => {
        dispatch(edgeGateways.resetAction({actionType:'query'}))  
        await dispatch(edgeGateways.query({
        // url: `http://localhost:4300/api/v6.1/identity/gateway/gateways/fetch-detail`, entity: 'edgeGateways', jsonData:
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/identity/gateway/gateways/fetch-detail`, entity: 'edgeGateways', jsonData:
        {
            "Context": {

            },
            "Records": [
            {
                "UniqueId": id
            }
            ]
        }

        }))
    }

    // const handleInnerFormChange: any = ({ value, field, data }: any) => {
    //     console.log('value, field, data', value, field, data)
    //     currentChange = { value, field, data, idx: 0 };
    //     const fields = R.split('.', field);
    //     const valueData = { ...data, [fields[1]]: value }; // inner data update
    //     console.log('selectedProduct?.OpenNetwork', selectedProducts)
    //     setSelectedProducts({ ...selectedProducts, [fields[0]]: valueData });
    // };

    const handleBacicInnerFormChange: any = (event: any, field: string) => {
        setSelectedEdgeGateway({ ...selectedEdgeGateway, [field]: event });
    }
    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
          '.',
          field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectedEdgeGateway({ ...selectedEdgeGateway, [fields[0]]: value });
    }

    useEffect(
        () => {
                if (parmas?.Id) {
                    fetchGatewayDetails(parmas?.Id)
                }
        },
        []
    )

    useEffect(
        () => {
            if (queryEdgeGatewaysData?.isSuccess) {
                setSelectedEdgeGateway(queryEdgeGatewaysData?.result?.items)
            }
        },
        [queryEdgeGatewaysData]
    )


    const back = () => {
        navigate(-1)
    }

    return (
        <>
            {queryEdgeGatewaysData?.isLoading ? <PageLoader /> :
                <BppGatewayComponent
                    onFormChange={handleInnerFormChange}
                    onInnerBasicFormChange={handleBacicInnerFormChange}
                    selectedEdgeGateway={selectedEdgeGateway}
                    back={back}
                    id={parmas?.id}
                />
            }
        </>
    )

}

export default BppGateway;